import React,{useState,useEffect} from 'react'
import './style.css'
import data from '../../../constant/data.json';
import SocailIconsabout from '../components/socailIconsabout';
import { getInterPolateValue } from '../../../utils/helper';
import Lottie from 'react-lottie';
import * as socials from '../../../assets/lottie/socials.json'
export default function AboutSection(props) {
    const [axisY,setPosition] = useState(0);
    const [isStoped,setIsStoped] = useState(true);
    const handleScroll = () => {
        const position = window.pageYOffset;
        setPosition(position); //start 1450 end 1927 
        if(isStoped && position > 1700){
            setIsStoped(false);
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const defaultOptions = {
        loop: false,
        autoplay: false, 
        animationData: socials,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
      const onLinkClick = (id)=>{
        if(id == "INSTA"){
            window.open(data.instagram, "_blank");
        }else if(id == "LINKED"){
            window.open(data.linkedIn, "_blank");
        }else if(id == "DRIBBLE"){
            window.open(data.dribble, "_blank");
        }else if(id == "BEHANCE"){
            window.open(data.behance, "_blank");
        }
    }
    return (
        <div className='about-sec-main'>
              <div style={{
                position:'absolute',
                left:20,
                top:115,
                zIndex:0,
                
            }}>
            <Lottie options={defaultOptions}
              height={500}
              width={612}
              isStopped={isStoped}
            //   isPaused={this.state.isPaused}
              />
                         </div>
            <div style={{
                backgroundColor:"black",
                position: 'absolute',
                width:100,
                height:125,
                top:100,
                left:200,
            }}  />
            <img src={require("../../../assets/images/iam.png")} className='about-iam-img' />

            <div style={{
                    position:'absolute',
                    left:20,
                    top:115,
                    zIndex:4,
                    width:612,
                    height:500
            }}>
 <div style={{ //drbble
                width:71,
                height:71,
                position:'absolute',
                bottom:192,
                left:138,
                borderRadius:100,
                cursor:"pointer",
                zIndex:4
              }} onClick={()=> onLinkClick("DRIBBLE")} />
               <div style={{ // behance
                width:71,
                height:71,
                position:'absolute',
                cursor:"pointer",

                bottom:159,
                left:199,
                borderRadius:100
              }} onClick={()=> onLinkClick("BEHANCE")} />
                 <div style={{
                width:71,
                height:71,
                 //linked in
                position:'absolute',
                cursor:"pointer",

                bottom:88,
                left:199,
                borderRadius:100
              }} onClick={()=> onLinkClick("LINKED")} />
                  <div style={{
                width:71,
                height:71,
                //insta
                position:'absolute',
                cursor:"pointer",

                bottom:122,
                left:137,
                borderRadius:100
              }} onClick={()=> onLinkClick("INSTA")} />

            </div>
           
            {/* <SocailIconsabout /> */}
          
            <div className='about-text-container'>
                <p className='about-header-text'>ABOUT ME</p>
                <p className='about-content-text'>{data.about1}</p>
                <p className='about-content-text'>{data.about2}</p>
            </div>
            <img
            style={{
                left:getInterPolateValue(axisY,1450,2327,0,100,true),
                rotate:"270deg",
                zIndex:3,
                transform: `rotate(${getInterPolateValue(axisY,1450,2327,0,90,true)}deg)`
                // transform:
                // rotate:`${getInterPolateValue(axisY,1450,1927,-90,0,true)}deg`
            }}
            src={require("../../../assets/images/ahsafdp.png")} className='about-dp-img' />
        </div>
    )
}
